var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 13.0491L16 8.88242M16 8.88242L11.8333 4.71575M16 8.88242H6M8.5 13.0491C8.5 13.2954 8.5 13.4186 8.49084 13.5252C8.39569 14.6341 7.57905 15.5465 6.48753 15.7635C6.38252 15.7844 6.26001 15.798 6.01529 15.8252L5.16412 15.9197C3.8854 16.0618 3.24601 16.1329 2.73805 15.9703C2.06078 15.7536 1.50785 15.2587 1.21765 14.6095C1 14.1226 1 13.4793 1 12.1927V5.57216C1 4.28555 1 3.64225 1.21765 3.15535C1.50785 2.50615 2.06078 2.01125 2.73805 1.79452C3.24601 1.63197 3.88538 1.70302 5.16412 1.8451L6.01529 1.93967C6.2601 1.96687 6.3825 1.98047 6.48753 2.00136C7.57905 2.21838 8.39569 3.13078 8.49084 4.23959C8.5 4.34628 8.5 4.46944 8.5 4.71575",
    stroke: "#FF2D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout3);
export default __webpack_public_path__ + "static/media/logout (3).ab2f95a3479d19e024d8b7b2c7d4ffdf.svg";
export { ForwardRef as ReactComponent };